/**
 * DS Compare — Status components
 * ---------------------------------------------------------------
 * Both status nodes become proper components instead of bare text lines:
 *   #dscmp-uploadstate — frosted overlay INSIDE the dropzone
 *   #dscmp-urlstate    — overlay ON TOP of the link row while loading,
 *                          so nothing pops open below and shifts the layout.
 *                          Errors drop below as a card (they need the room).
 */
(function () {
  var wrappedDrop = false;
  var wrappedUrl = false;

  /* ---------- Photo status → inside the dropzone ---------- */
  function wrapDropzone() {
    if (wrappedDrop) return;
    var dropzone = document.getElementById('dscmp-upload');
    var status = document.getElementById('dscmp-uploadstate');
    if (!dropzone || !status || !dropzone.parentNode) return;
    wrappedDrop = true;

    var wrap = document.createElement('div');
    wrap.className = 'dscmp-dropwrap';
    dropzone.parentNode.insertBefore(wrap, dropzone);
    wrap.appendChild(dropzone);
    wrap.appendChild(status);
    status.classList.add('dscmp-dropstate');
  }

  /* ---------- Link status → over the input + button row ---------- */
  function wrapUrlRow() {
    if (wrappedUrl) return;
    var row = document.querySelector('.dscmp-urlrow');
    var status = document.getElementById('dscmp-urlstate');
    if (!row || !status || !row.parentNode) return;
    wrappedUrl = true;

    var wrap = document.createElement('div');
    wrap.className = 'dscmp-urlwrap';
    row.parentNode.insertBefore(wrap, row);
    wrap.appendChild(row);
    wrap.appendChild(status);
  }

  /* ---------- Copy per state ---------- */
  function copyFor(text, isError, kind) {
    if (isError) {
      return {
        title: kind === 'url' ? 'Couldn’t read that page' : 'Couldn’t read that photo',
        sub: text
      };
    }
    if (/reading/i.test(text)) {
      return { title: 'Reading your photo', sub: 'Checking the label…' };
    }
    if (/opening/i.test(text)) {
      return { title: 'Opening that page', sub: 'Reading the product details…' };
    }
    return {
      title: 'Identifying the product',
      sub: 'Looking up its ingredients and price…'
    };
  }

  function decorate(status, kind) {
    if (!status || status.hidden) return;
    if (status.dataset.dscmpDecorated === status.innerHTML) return;

    var text = (status.textContent || '').trim();
    if (!text) return;

    var isError = status.classList.contains('is-error');
    var c = copyFor(text, isError, kind);

    var icon = isError
      ? '<span class="dscmp-status__icon dscmp-status__icon--err">!</span>'
      : '<span class="dscmp-status__ring"></span>';

    var html =
      icon +
      '<span class="dscmp-status__body">' +
        '<b>' + escapeHtml(c.title) + '</b>' +
        '<span>' + escapeHtml(c.sub) + '</span>' +
      '</span>';

    status.innerHTML = html;
    status.dataset.dscmpDecorated = html;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var bound = { photo: false, url: false };

  function bind(id, kind, flag) {
    var el = document.getElementById(id);
    if (!el || bound[flag]) return;
    bound[flag] = true;
    decorate(el, kind);
    new MutationObserver(function () { decorate(el, kind); })
      .observe(el, { childList: true, attributes: true, attributeFilter: ['hidden', 'class'] });
  }

  var mo = new MutationObserver(function () {
    wrapDropzone();
    wrapUrlRow();
    bind('dscmp-uploadstate', 'photo', 'photo');
    bind('dscmp-urlstate', 'url', 'url');
  });

  function start() {
    wrapDropzone();
    wrapUrlRow();
    bind('dscmp-uploadstate', 'photo', 'photo');
    bind('dscmp-urlstate', 'url', 'url');
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
